var _excluded = ["children", "className", "nested", "header", "horizontal", "animated", "hidePanelBackdrop"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { APanel } from "../APanel";
import ASkeletonHeader from "./ASkeletonHeader";
import "./ASkeleton.scss";
var baseClass = "a-skeleton";
var ASkeleton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    nested = _ref.nested,
    header = _ref.header,
    horizontal = _ref.horizontal,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? true : _ref$animated,
    _ref$hidePanelBackdro = _ref.hidePanelBackdrop,
    hidePanelBackdrop = _ref$hidePanelBackdro === void 0 ? false : _ref$hidePanelBackdro,
    rest = _objectWithoutProperties(_ref, _excluded);
  var ContainerComponent = hidePanelBackdrop ? "span" : APanel;
  var className = baseClass;
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  if (nested) {
    className += " ".concat(baseClass, "--nested");
  }
  if (horizontal) {
    className += " ".concat(baseClass, "--horizontal");
  }
  if (animated) {
    className += " ".concat(baseClass, "--animated");
  }
  var content = horizontal ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(baseClass, "__wrap")
  }, children) : children;
  return /*#__PURE__*/React.createElement(ContainerComponent, _extends({
    ref: ref,
    className: className
  }, rest), header && /*#__PURE__*/React.createElement(ASkeletonHeader, null), content);
});
ASkeleton.propTypes = {
  /**
   * String representing class names to be passed to component container
   */
  className: PropTypes.string,
  /**
   * Automatically add a header component
   */
  header: PropTypes.bool,
  /**
   * Set if nesting inside another ASkeleton
   * */
  nested: PropTypes.bool,
  /**
   * Use with `nested` to display sub panels horizontally
   */
  horizontal: PropTypes.bool,
  /**
   * Show a shine keyframe animation to indicate loading
   */
  animated: PropTypes.bool,
  /**
   * Use a <span> wrapper instead of `APanel`
   */
  hidePanelBackdrop: PropTypes.bool
};
ASkeleton.displayName = "ASkeleton";
export default ASkeleton;